<template>
  <div class="cancelar-demanda-container">
    <v-layout row class="justify-end">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn flat class="text-capitalize" color="grey" dark v-on="on">
            Cancelar Contratação
          </v-btn>
        </template>

        <v-card>
          <v-card-text class="primary modal-title">
            <span>Motivo do Cancelamento</span>
          </v-card-text>

          <v-container class="pa-3 white mt-3">
            <v-textarea
                placeholder="Informe o motivo do cancelamento"
                v-model="motivo"
                :rules="motivoRules">
              <template v-slot:label>Motivo</template>
            </v-textarea>
          </v-container>

          <v-card-actions class="pa-3">
            <v-btn color="blue darken-1" outline style="border-radius: 3px" flat @click="dialog = false">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="primary white--text" style="border-radius: 3px" flat @click="cancelarDemanda">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>

    import actionTypes from "@/commons/constants/action-types";

    export default {
      name: 'CredenciamentoCancelarDemanda',
      props: {
        demandaId: null,
      },
      data () {
        return {
          dialog: false,
          motivo: '',
          motivoRules: [
            v => (v && v.trim().length > 0) || 'O motivo é obrigatório',
            v => (v && v.trim().length >= 5) || 'O motivo deve ter no mínimo 5 caracteres',
            v => (v && v.trim().length <= 300) || 'O motivo deve ter no máximo 300 caracteres',
          ],
        }
      },
      methods: {
        async cancelarDemanda() {
          try {
            this.habilitarLoadingGlobal()
            const dados = {
              demandaId: this.demandaId,
              dados: {
                situacao: 'CANCELADA',
                justificativaCancelamento: this.motivo,
                itens: []
              }
            }

            const resposta = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.EDITAR_CANCELAR_DEMANDA, dados)

            if (resposta) {
              this.dialog = false
              this.$emit('atualizar')
            }
            this.mostrarNotificacaoSucessoDefault()
            this.desabilitarLoadingGlobal()
          } catch (e) {
            this.desabilitarLoadingGlobal()
          }
        }
      }
    }
  </script>

  <style>
    .custom-header thead th {
      color: #0067a5 !important;
    }
    .cancelar-demanda-container .v-layout {
      justify-content: flex-end !important;
    }


  </style>